module.exports = __webpack_public_path__ + "static/media/clients-05.b913b150.svg";